// components/blocks/ImageBlock.jsx
import React from 'react';
import styles from './ImageBlock.module.css';

const ImageBlock = ({ block }) => {
  return (
    <div className={styles.imageBlock}>
      <p>📷 Image selected: {block.url ? block.url.split('/').pop() : 'No file yet'}</p>
      <p>Use the file picker below to upload an image.</p>
    </div>
  );
};

export default ImageBlock;
